export default {
  title: {},
  group: {},
  filterContainer: {
    '& $title': {
      font: data => '500 16px/1.25 ' + data.fontFamily1,
      padding: '7px 45px 0 20px',
      position: 'relative',
      fontSize:'16px',
      '&:first-of-type': {
        paddingTop: ' 11px'
      },
      '@media (min-width: 1001px)': {
        borderBottom: 'none',
        fontWeight: '500'
      },
      '&:lang(ar)':{
        paddingRight:'20px',
        paddingLeft:'45px'
      }
    },
    '& $group': {
      padding: '13px 20px 7px',
      background: '#fff',
      margin: '0'
    }
  }
};
